export const flashFeed = [
  {
    id: 'k1',
    time: '13:42',
    status: '刚刚',
    category: '明星八卦',
    title: '同框路透再添新素材，时间线已更新至第四段',
    summary:
      '有网友补交了停车场角度画面，编辑按时间顺序重新整理，事件前后衔接更为完整。',
    source: '网友投稿 · 已初筛',
    comments: 1284,
    likes: 3268,
    heat: '8.6 万',
    cover:
      'https://readdy.ai/api/search-image?query=stylized%20abstract%20collage%20of%20camera%20flash%20and%20torn%20magazine%20page%20on%20warm%20crimson%20background%2C%20paper%20texture%2C%20editorial%20art%20direction%2C%20high%20detail%2C%20no%20people&width=400&height=300&seq=hl-feed-01&orientation=landscape',
  },
  {
    id: 'k2',
    time: '13:05',
    status: '核实中',
    category: '网红历史',
    title: '旧直播切片被重新翻出，早期发言引发新一轮讨论',
    summary: '投稿者提供了完整直播回放时间点，编辑正在核对前后语境。',
    source: '聊天记录 · 待核实',
    comments: 962,
    likes: 2140,
    heat: '6.1 万',
    cover:
      'https://readdy.ai/api/search-image?query=stylized%20abstract%20glowing%20smartphone%20screen%20with%20floating%20notification%20cards%20on%20warm%20amber%20background%2C%20soft%20neon%20glow%2C%20editorial%20art%20direction%2C%20high%20detail%2C%20no%20people&width=400&height=300&seq=hl-feed-02&orientation=landscape',
  },
  {
    id: 'k3',
    time: '12:31',
    status: '已曝光',
    category: '娱乐瓜',
    title: '综艺未播片段流出，嘉宾临场反应被反复讨论',
    summary: '三段素材按录制顺序整理完毕，节目组暂未对外说明。',
    source: '视频素材 · 已整理',
    comments: 736,
    likes: 1890,
    heat: '5.4 万',
    cover:
      'https://readdy.ai/api/search-image?query=stylized%20abstract%20film%20strip%20ribbon%20curling%20over%20warm%20crimson%20background%20with%20popcorn%20scatter%2C%20editorial%20collage%20texture%2C%20high%20detail%2C%20no%20people&width=400&height=300&seq=hl-feed-03&orientation=landscape',
  },
  {
    id: 'k4',
    time: '11:58',
    status: '热评中',
    category: '素人爆料',
    title: '剧组探班目击记录公开，后台细节被逐条比对',
    summary: '投稿附有现场时间戳与照片，评论区已开始交叉验证。',
    source: '网友投稿 · 已初筛',
    comments: 548,
    likes: 1320,
    heat: '4.2 万',
    cover:
      'https://readdy.ai/api/search-image?query=stylized%20abstract%20sealed%20paper%20envelope%20and%20small%20microphone%20on%20warm%20amber%20background%2C%20editorial%20collage%20texture%2C%20high%20detail%2C%20no%20people&width=400&height=300&seq=hl-feed-04&orientation=landscape',
  },
  {
    id: 'k5',
    time: '11:20',
    status: '已曝光',
    category: '明星八卦',
    title: '品牌活动后台花絮流出，座位安排被解读出多层信息',
    summary: '现场照片与流程图被并列整理，网友们给出了不同版本的解读。',
    source: '视频素材 · 已整理',
    comments: 431,
    likes: 980,
    heat: '3.5 万',
    cover:
      'https://readdy.ai/api/search-image?query=stylized%20abstract%20velvet%20rope%20and%20stage%20spotlight%20beam%20on%20warm%20crimson%20background%2C%20editorial%20collage%20texture%2C%20high%20detail%2C%20no%20people&width=400&height=300&seq=hl-feed-05&orientation=landscape',
  },
  {
    id: 'k6',
    time: '10:47',
    status: '待筛选',
    category: '网红历史',
    title: '账号改名时间线被整理，早期合作记录一并曝光',
    summary: '投稿者按照年份梳理了关键节点，编辑正在补充可考来源。',
    source: '聊天记录 · 待核实',
    comments: 318,
    likes: 764,
    heat: '2.8 万',
    cover:
      'https://readdy.ai/api/search-image?query=stylized%20abstract%20timeline%20ribbon%20with%20floating%20social%20media%20cards%20on%20warm%20amber%20background%2C%20editorial%20collage%20texture%2C%20high%20detail%2C%20no%20people&width=400&height=300&seq=hl-feed-06&orientation=landscape',
  },
];

export const hotWords = [
  { word: '深夜同框', count: '26.8万' },
  { word: '直播翻车', count: '18.4万' },
  { word: '未播片段', count: '12.7万' },
  { word: '人设考古', count: '9.6万' },
  { word: '探班目击', count: '7.3万' },
  { word: '票数争议', count: '5.1万' },
];

export const updateTimeline = [
  { time: '13:42', text: '新增 3 条明星八卦线索' },
  { time: '12:31', text: '整理 2 段娱乐瓜视频素材' },
  { time: '11:20', text: '发布 1 组网红历史聊天记录' },
  { time: '10:05', text: '开启今日素人爆料筛选' },
];